<template>
	<card-seplag v-if="dadosServidor" :titulo="dadosServidor.numrMatricula + ' - ' + dadosServidor.nomePessoa">

		<div class="p-col-12 avisos">
			<p>Siga os passos a seguir para concluir essa Validação: </p>
			<ol>
				<li class="passosSeguir">
					Valide ou Rejeite a foto pessoal
				</li>
				<li class="passosSeguir">
					Valide ou Rejeite todos os arquivos comprobatório dos documentos enviados
				</li>
				<li class="passosSeguir">
					Valide ou Rejeite o arquivo comprobatório do endereço
				</li>
				<li class="passosSeguir">
					Valide ou Rejeite o vinculo informado pelo servidor para concluir a validação
				</li>
			</ol>
		</div>
		<Message class="p-col-12"
			v-if="dadosServidor.enderecoEnviado.length > 0 && dadosServidor.enderecoEnviado[0].arquivosEndereco.length > 0 && dadosServidor.enderecoEnviado[0].arquivosEndereco[0].flagValidado == 'S'"
			:closable="false" severity="success"> O arquivo comprobatório do endereço já foi validado por você ou por
			outra chefia de outro vínculo</Message>
		<Message class="p-col-12"
			v-if="dadosServidor.flagDocumentosValidados && dadosServidor.flagDocumentosValidados == 'S'"
			:closable="false" severity="success"> Os arquivos comprobatórios dos documentos já foram validados por você
			ou por outra
			chefia de outro vínculo</Message>
		<div class="p-col-12">
			<Fieldset legend="Foto Pessoal" v-if="dadosServidor.dadosPessoais.arquivosDadoPessoal.length > 0">
				<div class="p-col-12">
					<div class="p-grid p-fluid centralizaContainerFoto">
						<Rotulo cols="12 6 6" class="centralizaContainerFoto"
							v-if="dadosServidor.dadosPessoais.arquivosDadoPessoal.length > 0 && dadosServidor.dadosPessoais.arquivosDadoPessoal[0].flagValidado == 'N' ||
								dadosServidor.dadosPessoais.arquivosDadoPessoal.length > 0 && !dadosServidor.dadosPessoais.arquivosDadoPessoal[0].flagValidado">
							<div class="campoFoto">
								<img v-if="imagemFoto" :src="imagemFoto" alt="Cropped Image" class="imagemResponsiva" />
							</div>
						</Rotulo>

						<Rotulo cols="12 6 6" class="centralizaContainerFoto"
							v-if="!(dadosServidor.dadosPessoais.arquivosDadoPessoal.length > 0 && dadosServidor.dadosPessoais.arquivosDadoPessoal[0].flagValidado == 'N' ||
								dadosServidor.dadosPessoais.arquivosDadoPessoal.length > 0 && !dadosServidor.dadosPessoais.arquivosDadoPessoal[0].flagValidado)">
							<div class="campoFoto">
								<img v-if="imagemFoto" :src="imagemFoto" alt="Cropped Image" class="imagemResponsiva" />
							</div>
						</Rotulo>

						<Rotulo cols="12 6 6"
							v-if="dadosServidor.dadosPessoais.arquivosDadoPessoal.length > 0 && dadosServidor.dadosPessoais.arquivosDadoPessoal[0].flagValidado == 'N' ||
								dadosServidor.dadosPessoais.arquivosDadoPessoal.length > 0 && !dadosServidor.dadosPessoais.arquivosDadoPessoal[0].flagValidado">
							<div class="campoFoto p-col-12 p-md-12 column">
								<div class="p-col-12 p-md-8 ajusteBotao">
									<Button label="Validar" class="p-button-raised p-button-rounded p-button-success"
										icon="pi pi-check-circle"
										@click="validarModal('Foto', dadosServidor.dadosPessoais.arquivosDadoPessoal[0])" />
									<Button label="Rejeitar" class="p-button-raised p-button-rounded p-button-danger"
										icon="pi pi-exclamation-circle"
										@click="abrirModal(4, dadosServidor.dadosPessoais.arquivosDadoPessoal[0])" />
								</div>
							</div>
						</Rotulo>
						<!-- <div class="p-col-12 p-md-5">
														<div class="campoFoto">
																<img v-if="imagemFoto" :src="imagemFoto" alt="Cropped Image" class="imagemResponsiva" />
														</div>
												</div>
												<div class="campoFoto p-col-12 p-md-7 ajusteBotao">
														<div class="p-col-12 p-md-8 ajusteBotao">
																<div class="ajusteBotao">
																		<Button label="Validar" class="p-button-raised p-button-rounded p-button-success"
																				icon="pi pi-check-circle"
																				@click="validarFoto(dadosServidor.dadosPessoais.arquivosDadoPessoal[0])" />
																</div>
																<Button label="Rejeitar" class="p-button-raised p-button-rounded p-button-danger"
																		icon="pi pi-exclamation-circle"
																		@click="abrirModal(4, dadosServidor.dadosPessoais.arquivosDadoPessoal[0])" />
														</div>
												</div> -->
					</div>
				</div>
			</Fieldset>
		</div>

		<div class="p-col-12"
			v-if="dadosServidor.enderecoEnviado.length > 0 && dadosServidor.enderecoEnviado[0].arquivosEndereco.length > 0 && dadosServidor.enderecoEnviado[0].arquivosEndereco[0].flagValidado == 'N' ||
				dadosServidor.enderecoEnviado.length > 0 && dadosServidor.enderecoEnviado[0].arquivosEndereco.length > 0 && !dadosServidor.enderecoEnviado[0].arquivosEndereco[0].flagValidado">
			<Fieldset legend="Endereço" class="">
				<div class="p-grid p-fluid">
					<Rotulo nome="CEP" cols='12 2'>
						<InputMask mask="99999-999" v-model="dadosServidor.enderecoEnviado[0].descCep"
							placeholder="99999-999" @blur="buscaCEP()" disabled />
					</Rotulo>
					<Rotulo nome="UF" cols='12 2'>
						<Dropdown v-model="dadosServidor.enderecoEnviado[0].uf" :options="ufAll" optionLabel="siglUf"
							placeholder="Selecione.." disabled />
					</Rotulo>
					<Rotulo nome="Cidade" cols='12 4'>
						<Dropdown v-model="dadosServidor.enderecoEnviado[0].cidade" :options="cidades"
							optionLabel="nomeCidade" placeholder="Selecione.." disabled />
					</Rotulo>
					<Rotulo nome="Bairro" cols='12 4'>
						<InputText type="text" v-model="dadosServidor.enderecoEnviado[0].endrBairro" disabled />
					</Rotulo>
					<Rotulo nome="Tipo logradouro" cols='12 2'>
						<InputText type="text" v-model="dadosServidor.enderecoEnviado[0].endrTipoLogradouro" disabled />
					</Rotulo>
					<Rotulo nome="Logradouro" cols='12 5'>
						<InputText type="text" v-model="dadosServidor.enderecoEnviado[0].endrLogradouro" disabled />
					</Rotulo>
					<Rotulo nome="Complemento" cols='12 4'>
						<InputText type="text" v-model="dadosServidor.enderecoEnviado[0].endrComplemento" disabled />
					</Rotulo>
					<Rotulo nome="Número" cols='12 1'>
						<InputText type="text" v-model="dadosServidor.enderecoEnviado[0].endrNumero" disabled />
					</Rotulo>
					<div class="p-col-12 p-md-4"
						v-if="dadosServidor.enderecoEnviado[0].arquivosEndereco.length > 0 && dadosServidor.enderecoEnviado[0].arquivosEndereco[0].statArquivoEndereco == 'ENVIADO'">
						<Button label="Visualizar Arquivo" icon="pi pi-file-pdf"
							@click="visualizarDocumento(dadosServidor.enderecoEnviado[0], 1)"
							class="p-button-raised p-button-rounded p-button-warning" />
					</div>
					<div class="p-col-12 p-md-4"
						v-if="dadosServidor.enderecoEnviado[0].arquivosEndereco.length > 0 && !dadosServidor.enderecoEnviado[0].arquivosEndereco[0].flagValidado">
						<Button label="Validar" class="p-button-raised p-button-rounded p-button-success"
							icon="pi pi-check-circle"
							@click="validarModal('Endereço', dadosServidor.enderecoEnviado[0].arquivosEndereco[0])" />
					</div>
					<div class="p-col-12 p-md-4"
						v-else-if="dadosServidor.enderecoEnviado[0].arquivosEndereco.length > 0 && dadosServidor.enderecoEnviado[0].arquivosEndereco[0].flagValidado && dadosServidor.enderecoEnviado[0].arquivosEndereco[0].flagValidado == 'N'">
						<Button label="Validar" class="p-button-raised p-button-rounded p-button-success"
							icon="pi pi-check-circle"
							@click="validarModal('Endereço', dadosServidor.enderecoEnviado[0].arquivosEndereco[0])" />
					</div>
					<div class="p-col-12 p-md-4"
						v-if="dadosServidor.enderecoEnviado[0].arquivosEndereco.length > 0 && !dadosServidor.enderecoEnviado[0].arquivosEndereco[0].flagValidado">
						<Button label="Rejeitar" class="p-button-raised p-button-rounded p-button-danger"
							icon="pi pi-exclamation-circle"
							@click="abrirModal(3, dadosServidor.enderecoEnviado[0].arquivosEndereco[0])" />
					</div>
					<div class="p-col-12 p-md-4"
						v-else-if="dadosServidor.enderecoEnviado[0].arquivosEndereco.length > 0 && dadosServidor.enderecoEnviado[0].arquivosEndereco[0].flagValidado && dadosServidor.enderecoEnviado[0].arquivosEndereco[0].flagValidado == 'N'">
						<Button label="Rejeitar" class="p-button-raised p-button-rounded p-button-danger"
							icon="pi pi-exclamation-circle"
							@click="abrirModal(3, dadosServidor.enderecoEnviado[0].arquivosEndereco[0])" />
					</div>
				</div>
			</Fieldset>
		</div>
		<div class="p-col-12"
			v-if="dadosServidor.flagDocumentosValidados && dadosServidor.flagDocumentosValidados == 'N'">
			<Fieldset legend="Documentos" class="">
				<Accordion v-if="dadosServidor && dadosServidor.documentosEnviados.length > 0">
					<AccordionTab v-for="(documento, index) in dadosServidor.documentosEnviados"
						:key="documento.idenDocumento" :active.sync="controleAccord[index]">
						<template slot="header">
							{{ documento.tipoDocumento.descTipoDocumento }}
							<span class="pendenteEdicao"
								v-if="documento.arquivosDocumento.length > 0 && !documento.arquivosDocumento[0].flagValidado">
								- Pendente de Validação</span>
							<span class="pendenteEdicao"
								v-else-if="documento.arquivosDocumento.length > 0 && documento.arquivosDocumento[0].flagValidado && documento.arquivosDocumento[0].flagValidado == 'N'">
								- Pendente de Validação</span>
						</template>
						<div class="p-grid p-fluid">
							<div class="p-col-12" v-if="documento.numrDocumento || documento.descNumero">
								<label><strong>Número do Documento: </strong>{{
									documento.numrDocumento ?
										documento.numrDocumento : documento.descNumero ? documento.descNumero : ''
								}}</label>
							</div>
							<div class="p-col-12" v-if="documento.dataExpedicao">
								<label><strong>Data de Expedição: </strong>{{ documento.dataExpedicao }}</label>
							</div>
							<div class="p-col-12" v-if="documento.dataValidade">
								<label><strong>Data de Validade: </strong> {{ documento.dataValidade }}</label>
							</div>
							<div class="p-col-12" v-if="documento.clasCategoria">
								<label><strong>Classe Categoria:</strong> {{ documento.clasCategoria }}</label>
							</div>
							<div class="p-col-12" v-if="documento.clasOrgao">
								<label><strong>Classe Órgão:</strong> {{ documento.clasOrgao }}</label>
							</div>
							<div class="p-col-12" v-if="documento.clasTipo">
								<label><strong>Classe Tipo:</strong> {{ documento.clasTipo }}</label>
							</div>
							<div class="p-col-12" v-if="documento.numrSecao">
								<label><strong>Número Seção:</strong> {{ documento.numrSecao }}</label>
							</div>
							<div class="p-col-12" v-if="documento.numrSerie">
								<label><strong>Número Série:</strong> {{ documento.numrSerie }}</label>
							</div>
							<div class="p-col-12" v-if="documento.numrZona">
								<label><strong>Número Zona:</strong> {{ documento.numrZona }}</label>
							</div>
							<div class="p-col-12" v-if="documento.orgaoDocumento">
								<label><strong>Órgão Documento:
									</strong>{{ documento.orgaoDocumento.descOrgaoDocumento }}</label>
							</div>
							<div class="p-col-12 p-md-6" v-if="documento.uf">
								<label><strong>UF: </strong>{{ documento.uf.nomeUf }}</label>
							</div>
							<div class="p-col-12 p-md-6" v-if="documento.pais">
								<label><strong>País: </strong>{{ documento.pais.nomePais }}</label>
							</div>
							<div class="p-col-12"></div>
							<div class="p-col-12 p-md-4" v-if="documento.arquivosDocumento.length > 0">
								<Button label="Visualizar Arquivo" icon="pi pi-file-pdf"
									@click="visualizarDocumento(documento, 2)"
									class="p-button-raised p-button-rounded p-button-warning" />
							</div>
							<div class="p-col-12 p-md-4"
								v-if="documento.arquivosDocumento.length > 0 && !documento.arquivosDocumento[0].flagValidado">
								<Button label="Validar" class="p-button-raised p-button-rounded p-button-success"
									icon="pi pi-check-circle"
									@click="validarModal('Arquivo', documento.arquivosDocumento[0])" />
							</div>
							<div class="p-col-12 p-md-4"
								v-else-if="documento.arquivosDocumento.length > 0 && documento.arquivosDocumento[0].flagValidado && documento.arquivosDocumento[0].flagValidado == 'N'">
								<Button label="Validar" class="p-button-raised p-button-rounded p-button-success"
									icon="pi pi-check-circle"
									@click="validarModal('Arquivo', documento.arquivosDocumento[0])" />
							</div>
							<div class="p-col-12 p-md-4"
								v-if="documento.arquivosDocumento.length > 0 && !documento.arquivosDocumento[0].flagValidado">
								<Button label="Rejeitar" class="p-button-raised p-button-rounded p-button-danger"
									icon="pi pi-exclamation-circle"
									@click="abrirModal(1, documento.arquivosDocumento[0])" />
							</div>
							<div class="p-col-12 p-md-4"
								v-else-if="documento.arquivosDocumento.length > 0 && documento.arquivosDocumento[0].flagValidado && documento.arquivosDocumento[0].flagValidado == 'N'">
								<Button label="Rejeitar" class="p-button-raised p-button-rounded p-button-danger"
									icon="pi pi-exclamation-circle"
									@click="abrirModal(1, documento.arquivosDocumento[0])" />
							</div>
						</div>
					</AccordionTab>
				</Accordion>
			</Fieldset>
		</div>
		<div class="p-col-12">
			<Fieldset legend="Vínculo" class="">
				<div class="p-grid p-fluid">
					<Rotulo nome="Categoria:" cols='12'>
						<InputText type="text" v-model="dadosServidor.vinculo.descCategoria" disabled />
					</Rotulo>
					<Rotulo nome="Cargo:" cols='12 9'>
						<InputText type="text" v-model="dadosServidor.vinculo.cargo.descSeap" disabled />
					</Rotulo>
					<Rotulo nome="Data de Exercício:" cols='12 3'>
						<InputText type="text" v-model="dadosServidor.vinculo.dataExercicio" disabled />
					</Rotulo>
					<Rotulo nome="Setor:" cols='12'>
						<InputText type="text" v-model="dadosServidor.vinculo.unidade.descUnidade" disabled />
					</Rotulo>
					<Rotulo nome="Órgão:" cols='12'>
						<InputText type="text" v-model="dadosServidor.vinculo.orgao.descOrgao" disabled />
					</Rotulo>
					<Rotulo nome="Perfil de ingresso:" cols='12'>
						<InputText type="text" v-if="dadosServidor.perfilIngresso"
							v-model="dadosServidor.perfilIngresso.descPerfilIngresso" disabled />
					</Rotulo>
					<div class="p-col-12 p-md-4">
						<Button label="Voltar" @click="voltar()" class="p-button-raised p-button-rounded"
							icon="pi pi-angle-left" />
					</div>
					<div class="p-col-12 p-md-4">
						<Button label="Validar" @click="validarModal('Vinculo', null)"
							class="p-button-raised p-button-rounded p-button-success" icon="pi pi-check-circle" />
					</div>
					<div class="p-col-12 p-md-4">
						<Button label="Rejeitar" @click="abrirModal(2)"
							class="p-button-raised p-button-rounded p-button-danger" icon="pi pi-exclamation-circle" />
					</div>
				</div>
			</Fieldset>
		</div>
		<Dialog header="Selecione um Motivo" :visible.sync="modalMotivoAtivo" :style="{ width: '30vw' }" :modal="true">
			<div class="p-grid p-fluid" style="margin-bottom: 4vw;">
				<Rotulo cols="12">
					<Dropdown :options="motivoRejeicao" v-model="motivo" optionLabel="descMotivoRejeicao"
						placeholder="Selecione um motivo" />
					<br>
					<h3>Justificativa</h3>
					<Textarea v-model="justificativa" :autoResize="false" rows="5" cols="30" maxlength="200" />
					<p>{{ charactersRemaining }}/{{ maxCharacters }}</p>
				</Rotulo>
			</div>
			<template #footer>
				<Button label="Voltar" icon="pi pi-times" @click="fecharModal" class="p-button-text" />
				<Button label="Rejeitar" v-if="tipoMotivoRejeicao == 1" icon="pi pi-check" @click="rejeitarArquivo"
					class="p-button-text p-button-danger" autofocus />
				<Button label="Rejeitar" v-else-if="tipoMotivoRejeicao == 2" icon="pi pi-check"
					class="p-button-text p-button-danger" @click="rejeitarVinculo" autofocus />
				<Button label="Rejeitar" v-else-if="(tipoMotivoRejeicao == 4)" icon="pi pi-check"
					class="p-button-text p-button-danger" @click="rejeitarFoto" autofocus />
				<Button label="Rejeitar" v-else icon="pi pi-check" class="p-button-text p-button-danger"
					@click="rejeitarEndereco" autofocus />
			</template>
		</Dialog>
		<ExibirPDF v-if="pdfBase64" v-model="exibirPDFDocumento" :tamanhoTela="'70.vw'" :alturaTela="'30.vw'"
			:tituloTela="nomeModalPDF" :pdfElement="pdfBase64" />

		<Dialog :header="modal.titulo" v-if="modal.exibirExcluir" :visible.sync="modal.exibirExcluir" :modal="true"
			:contentStyle="'min-width:30rem;min-height: 10rem;'">
			<div class="center" style="padding-bottom: 2em;">
				<p>Deseja realmente validar a Etapa <strong>{{ modal.titulo }}?</strong></p>
				<p>Validar a atualização cadastral em desacordo com as normas legais, ensejará em processo disciplinar.
				</p>
			</div>
			<div class="p-col-12 ">
				<div class="p-grid p-fluid center">
					<Rotulo cols="12 4">
						<Button label="Sim, validar!" class="botao p-button-success"
							@click="selecionarTipoValidacao(modal.titulo, modal.item)" />
					</Rotulo>
					<Rotulo cols="12 4">
						<Button label="Não!" class="botao p-button-danger" @click="fecharModal()" />
					</Rotulo>
				</div>
			</div>
		</Dialog>
	</card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import ExibirPDF from '@/template/CardExibirPDF.vue'
import { baseApiUrl } from '@/config/global'

export default {
	name: "CHEFIAGERENCIA_VALIDACOES",
	components: { CardSeplag, Rotulo, ExibirPDF },
	data: function () {
		return {
			dadosServidor: null,
			motivo: null,
			justificativa: '',
			modalMotivoAtivo: false,
			exibirPDFDocumento: false,
			pdfBase64: "",
			nomeModalPDF: "MODAL PDF",
			tipoMotivoRejeicao: null,
			arquivoMotivacao: null,
			motivoRejeicao: [],
			motivoRejeicaoArquivo: [],
			motivoRejeicaoVinculo: [],
			motivoRejeicaoFoto: [],
			ufAll: [],
			cidades: [],
			controleAccord: [],
			tipoLogradouros: [],
			documento: null,
			imagemFoto: null,
			maxCharacters: 200,
			modal: {
				titulo: null,
				especie: null,
				exibir: false,
				exibirExcluir: false,
				item: null
			},
		}
	},
	computed: {
		charactersRemaining: function () {
			return this.maxCharacters - this.justificativa.length;
		}
	},
	methods: {
		async carregarDados() {
			if (this.$store.getters.getServSelecionado) {
				await this.$http.get(`${baseApiUrl}/tipologradouros/all`).then(res4 => {
					this.tipoLogradouros = res4.data
				})

				// Listar UF's
				await this.$http.get(`${baseApiUrl}/ufs/all`).then(res5 => {
					this.ufAll = res5.data
				})


				await this.$http.get(`${baseApiUrl}/motivosrejeicao/tipo/ARQUIVO`).then(res3 => {
					this.motivoRejeicaoArquivo = res3.data
				})

				await this.$http.get(`${baseApiUrl}/motivosrejeicao/tipo/VINCULO`).then(res3 => {
					this.motivoRejeicaoVinculo = res3.data
				})

				await this.$http.get(`${baseApiUrl}/motivosrejeicao/tipo/FOTO`).then(res3 => {
					this.motivoRejeicaoFoto = res3.data.sort((a, b) => {
						if (a.descMotivoRejeicao < b.descMotivoRejeicao) {
							return -1;
						}
						if (a.descMotivoRejeicao > b.descMotivoRejeicao) {
							return 1;
						}
						return 0;
					})
				})

				await this.$http.get(`${baseApiUrl}/vinculos/buscarVinculoCicloValidacao/${this.$store.getters.getServSelecionado.idenCicloPessoa}/${this.$store.getters.getUser.contaAcesso.pessoa.servidor.numrMatricula}/${this.$store.getters.getServSelecionado.idenVinculoCiclo}`).then(res => {
					this.dadosServidor = res.data[0]

					for (let i = 0; i < this.dadosServidor.documentosEnviados.length; i++) {
						this.controleAccord[i] = false
					}
					if (this.dadosServidor.enderecoEnviado.length > 0 && this.dadosServidor.enderecoEnviado[0].uf && this.dadosServidor.enderecoEnviado[0].uf.idenUf) {
						this.$http.get(`${baseApiUrl}/cidades/buscarPorIdenUf/${this.dadosServidor.enderecoEnviado[0].uf.idenUf}`).then(res2 => {
							this.cidades = res2.data
						})
					}
				})

				await this.$http.get(`${baseApiUrl}/arquivosrecad/download/${this.dadosServidor.dadosPessoais.arquivosDadoPessoal[0].arquivoRecad.idenArquivo}`).then(res => {
					this.documento = res
					this.imagemFoto = res.data
				})


			} else {
				this.$router.push({ name: 'CHEFIAGERENCIA_PENDENTE' })
			}
		},
		validarModal(etapaValidacao, data) {
			this.modal.item = data
			this.modal.exibirExcluir = true
			this.modal.titulo = etapaValidacao
		},
		fecharModal() {
			this.modal.exibir = false
			this.modal.exibirExcluir = false
			this.modal.item = null
			this.modal.titulo = null
			this.modal.especie = null
			this.modalMotivoAtivo = false
		},
		selecionarTipoValidacao(tipo, data) {
			if (tipo == 'Foto') {
				this.validarFoto(data);
			}

			if (tipo == 'Endereço') {
				this.validarEndereco(data)
			}

			if (tipo == 'Arquivo') {
				this.validarArquivo(data)
			}

			if (tipo == 'Vinculo') {
				this.validarVinculo()
			}
		},
		voltar() {
			this.$router.push({ name: 'CHEFIAGERENCIA_PENDENTE' })
		},
		abrirModal(tipo, arquivo = null) {
			if (tipo == 1) {
				this.motivoRejeicao = this.motivoRejeicaoArquivo
				this.arquivoMotivacao = arquivo
			} else if (tipo == 4) {
				this.motivoRejeicao = this.motivoRejeicaoFoto
				this.arquivoMotivacao = arquivo
			} else if (tipo == 3) {
				this.motivoRejeicao = this.motivoRejeicaoArquivo
				this.arquivoMotivacao = arquivo
			} else {
				this.motivoRejeicao = this.motivoRejeicaoVinculo
				this.arquivoMotivacao = null
			}
			this.tipoMotivoRejeicao = tipo
			this.modalMotivoAtivo = true
			this.motivo = null
		},
		validarVinculo() {
			let bodyPut = {
				idenEntidade: this.dadosServidor.idenVinculoCiclo,
				idenCicloPessoa: this.dadosServidor.idenCicloPessoa,
				numrMatriculaChefe: this.$store.getters.getUser.contaAcesso.pessoa.servidor.numrMatricula,
				flagValidado: "S",
				idenMotivoRejeicao: null,
				pathAplicacao: window.location.origin + "/recadastramento"
			}
			this.$http.put(`${baseApiUrl}/vinculos/validacaochefia`, JSON.stringify(bodyPut)).then(() => {
				this.$router.push({ name: 'CHEFIAGERENCIA_PENDENTE' })
			})
			this.modalMotivoAtivo = false
		},
		validarFoto(foto) {
			let bodyPut = {
				idenEntidade: foto.idenArquivoDadoPessoal,
				idenCicloPessoa: this.dadosServidor.idenCicloPessoa,
				numrMatriculaChefe: this.$store.getters.getUser.contaAcesso.pessoa.servidor.numrMatricula,
				flagValidado: "S",
				idenMotivoRejeicao: null,
				pathAplicacao: window.location.origin + "/recadastramento"
			}
			this.$http.put(`${baseApiUrl}/arquivosdadopessoal/validacaochefia`, JSON.stringify(bodyPut))
				.then(res => {
					this.$http.get(`${baseApiUrl}/vinculos/buscarVinculoPorCicloPessoa/${this.$store.getters.getServSelecionado.idenCicloPessoa}/${bodyPut.numrMatriculaChefe}`).then(res2 => {
						this.dadosServidor = res2.data[0]
						this.$toast.add({ severity: 'success', summary: res.data, life: 10000 });
						this.carregarDados()
					})
				}).finally(() => {
					this.fecharModal()
				})
		},
		validarArquivo(documento) {
			let bodyPut = {
				idenEntidade: documento.idenArquivoDocumento,
				idenCicloPessoa: this.dadosServidor.idenCicloPessoa,
				numrMatriculaChefe: this.$store.getters.getUser.contaAcesso.pessoa.servidor.numrMatricula,
				flagValidado: "S",
				idenMotivoRejeicao: null,
				pathAplicacao: window.location.origin + "/recadastramento"
			}
			this.$http.put(`${baseApiUrl}/arquivodocumentos/validacaochefia`, JSON.stringify(bodyPut)).then(res3 => {
				this.$http.get(`${baseApiUrl}/vinculos/buscarVinculoPorCicloPessoa/${this.$store.getters.getServSelecionado.idenCicloPessoa}/${bodyPut.numrMatriculaChefe}`).then(res => {
					this.dadosServidor = res.data[0]

					for (let i = 0; i < this.dadosServidor.documentosEnviados.length; i++) {
						this.controleAccord[i] = false
					}
					if (this.dadosServidor.enderecoEnviado.length > 0 && this.dadosServidor.enderecoEnviado[0].uf && this.dadosServidor.enderecoEnviado[0].uf.idenUf) {
						this.$http.get(`${baseApiUrl}/cidades/buscarPorIdenUf/${this.dadosServidor.enderecoEnviado[0].uf.idenUf}`).then(res2 => {
							this.cidades = res2.data
						})
					}
				})
				this.$toast.add({ severity: 'success', summary: res3.data, life: 10000 });
			}).finally(() => {
				this.carregarDados()
				this.fecharModal()
			})
		},
		validarEndereco(documento) {
			let bodyPut = {
				idenArquivoEndereco: documento.idenArquivoEndereco,
				idenCicloPessoa: this.dadosServidor.idenCicloPessoa,
				numrMatriculaChefe: this.$store.getters.getUser.contaAcesso.pessoa.servidor.numrMatricula,
				flagValidado: "S",
				idenMotivoRejeicao: null,
				pathAplicacao: window.location.origin + "/recadastramento"
			}
			this.$http.put(`${baseApiUrl}/arquivoenderecos/validacaochefia`, JSON.stringify(bodyPut)).then(res3 => {
				this.$http.get(`${baseApiUrl}/vinculos/buscarVinculoPorCicloPessoa/${this.$store.getters.getServSelecionado.idenCicloPessoa}/${bodyPut.numrMatriculaChefe}`).then(res => {
					this.dadosServidor = res.data[0]

					for (let i = 0; i < this.dadosServidor.documentosEnviados.length; i++) {
						this.controleAccord[i] = false
					}
					if (this.dadosServidor.enderecoEnviado.length > 0 && this.dadosServidor.enderecoEnviado[0].uf && this.dadosServidor.enderecoEnviado[0].uf.idenUf) {
						this.$http.get(`${baseApiUrl}/cidades/buscarPorIdenUf/${this.dadosServidor.enderecoEnviado[0].uf.idenUf}`).then(res2 => {
							this.cidades = res2.data
						})
					}
					this.$toast.add({ severity: 'success', summary: res3.data, life: 10000 });
				})
			}).finally(() => {
				this.carregarDados()
				this.fecharModal()
			})
		},
		rejeitarVinculo() {
			let bodyPut = {
				idenEntidade: this.dadosServidor.idenVinculoCiclo,
				idenCicloPessoa: this.dadosServidor.idenCicloPessoa,
				numrMatriculaChefe: this.$store.getters.getUser.contaAcesso.pessoa.servidor.numrMatricula,
				flagValidado: "N",
				idenMotivoRejeicao: this.motivo.idenMotivoRejeicao,
				pathAplicacao: window.location.origin + "/recadastramento",
				justificativaRejeicao: this.justificativa
			}
			this.$http.put(`${baseApiUrl}/vinculos/validacaochefia`, JSON.stringify(bodyPut)).then(() => {
				this.$router.push({ name: 'CHEFIAGERENCIA_PENDENTE' })
			})
			this.fecharModal()
		},
		rejeitarArquivo() {
			let bodyPut = {
				idenEntidade: this.arquivoMotivacao.idenArquivoDocumento,
				idenCicloPessoa: this.dadosServidor.idenCicloPessoa,
				numrMatriculaChefe: this.$store.getters.getUser.contaAcesso.pessoa.servidor.numrMatricula,
				flagValidado: "N",
				idenMotivoRejeicao: this.motivo.idenMotivoRejeicao,
				pathAplicacao: window.location.origin + "/recadastramento",
				justificativaRejeicao: this.justificativa
			}
			this.$http.put(`${baseApiUrl}/arquivodocumentos/validacaochefia`, JSON.stringify(bodyPut)).then(() => {
				this.$router.push({ name: 'CHEFIAGERENCIA_PENDENTE' })
			})
			this.fecharModal()
		},
		rejeitarEndereco() {
			let bodyPut = {
				idenArquivoEndereco: this.arquivoMotivacao.idenArquivoEndereco,
				idenCicloPessoa: this.dadosServidor.idenCicloPessoa,
				numrMatriculaChefe: this.$store.getters.getUser.contaAcesso.pessoa.servidor.numrMatricula,
				flagValidado: "N",
				idenMotivoRejeicao: this.motivo.idenMotivoRejeicao,
				pathAplicacao: window.location.origin + "/recadastramento",
				justificativaRejeicao: this.justificativa
			}
			this.$http.put(`${baseApiUrl}/arquivoenderecos/validacaochefia`, JSON.stringify(bodyPut)).then(() => {
				this.$router.push({ name: 'CHEFIAGERENCIA_PENDENTE' })
			})
			this.fecharModal()

		},
		rejeitarFoto() {
			let bodyPut = {
				idenEntidade: this.dadosServidor.dadosPessoais.arquivosDadoPessoal[0].idenArquivoDadoPessoal,
				idenCicloPessoa: this.dadosServidor.idenCicloPessoa,
				numrMatriculaChefe: this.$store.getters.getUser.contaAcesso.pessoa.servidor.numrMatricula,
				flagValidado: "N",
				idenMotivoRejeicao: this.motivo.idenMotivoRejeicao,
				pathAplicacao: window.location.origin + "/recadastramento",
				justificativaRejeicao: this.justificativa
			}
			this.$http.put(`${baseApiUrl}/arquivosdadopessoal/validacaochefia`, JSON.stringify(bodyPut)).then(() => {
				this.$router.push({ name: 'CHEFIAGERENCIA_PENDENTE' })
			})
			this.fecharModal()
			this.carregarDados()
		},
		visualizarDocumento(dado, tipo) {
			if (tipo == 1) {
				this.$http.get(`${baseApiUrl}/arquivosrecad/download/${dado.arquivosEndereco[0].arquivoRecad.idenArquivo}`).then(res3 => {
					this.pdfBase64 = res3.data
					this.nomeModalPDF = 'ARQUIVO COMPROBATÓRIO PARA VALIDAÇÃO DO ENDEREÇO'
					this.exibirPDFDocumento = true
				})
			} else {
				this.$http.get(`${baseApiUrl}/arquivosrecad/download/${dado.arquivosDocumento[0].arquivoRecad.idenArquivo}`).then(res3 => {
					this.pdfBase64 = res3.data
					this.nomeModalPDF = 'ARQUIVO COMPROBATÓRIO PARA VALIDAÇÃO'
					this.exibirPDFDocumento = true
				})
			}
		}
	},
	mounted() {
		this.carregarDados()
	}
}
</script>

<style>
.avisos {
	background-color: rgb(231 232 125 / 84%);
	/* Red */
	color: #000000;
	border-radius: 12px;
}

.passosSeguir {
	list-style-type: decimal-leading-zero;
	margin-left: 3vw;
}

.pendenteEdicao {
	color: orange;
}

.imagemResponsiva {
	display: flex;
	width: 14rem;
	justify-items: center;
	justify-content: center;
	align-items: center;
}

.centralizaContainerFoto {
	display: flex;
	align-items: center;
	justify-content: center;
}

.campoFoto {
	justify-content: center;
	align-items: center;
	flex-direction: column;
	display: flex;
	gap: 20px;
	width: 100%;
	height: 100%;
}

.ajusteBotao {
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 100%;
}

.flex-end {
	justify-content: flex-end;
}

.center {
	justify-content: center;
}

.space-between {
	justify-content: space-between;
}

.space-around {
	justify-content: space-around;
}

/* Flex Container */

.column {
	flex-direction: column;
}

/* Flex Item */
.item {
	margin: 5px;
	padding: 0 10px;
	background: tomato;
	text-align: center;
	font-size: 1.5em;
}

/* Indica que o conteúdo deve se expandir */
.flex {
	flex: 1;
}

@media screen and (max-width: 40em) {
	.column {
		min-height: 0px;
		flex-direction: column;
	}

	.imagemResponsiva {
		justify-items: center;
		justify-content: center;
		align-items: center;
		max-width: 100%;
		min-width: 100%;
	}
}


@media screen and (max-width: 48em) {
	.column {
		min-height: 0px;
		flex-direction: column;
	}

	.imagemResponsiva {
		justify-items: center;
		justify-content: center;
		align-items: center;
		max-width: 100%;
		min-width: 100%;
	}
}

@media screen and (max-width: 27em) {
	.column {
		min-height: 0px;
		flex-direction: column;
	}

	.imagemResponsiva {
		justify-items: center;
		justify-content: center;
		align-items: center;
		max-width: 100%;
		min-width: 70%;
	}
}

.center {
	justify-content: center;
	text-align: center;
	align-items: center;
}
</style>